<template>
  <div class="map-con">
  </div>
</template>
  
<script>
  import MobileDetect from 'mobile-detect';
  export default {
    name: 'clientToLogin',
    computed: {},
    data(){
      return {
        supportQuickAPP: false,
        mobileInfo: null,
        mobileModel: null,
      }
    },
    methods: {

    },

    mounted(){
      const href = decodeURIComponent(window.location.href)
      const index = href.indexOf('?')
      let queryString = '';
      if(index > -1){
        const lastIndex = href.length
        queryString = href.substring(index + 1, lastIndex)
        console.log('paramsString', queryString)
      }
      
      const _this = this;
      channelReady((bAvailable) => {
        // alert('是否支持快应用：' + bAvailable)
        if(bAvailable){
          const serviceNo = queryString && queryString.replace('serviceNo=','') || '';
          console.log('serviceNo', serviceNo)
          appRouter('com.hetu.message','/Login',{serviceNo})
        }
        _this.$router.replace(`/login?${queryString}`) 
      });
    }
  }
</script>

<style lang="less">
  .alertCon{
    width: 90%;
  }
</style>


// WEBPACK FOOTER //
// src/clientEntry/toLogin.vue